/**
 * @flow
 * */

import React, { Component } from 'react'

import MobileMediaQuery from '../../core/MediaQueries/MobileMediaQuery'
import AboveTabletMediaQuery from '../../core/MediaQueries/AboveTabletMediaQuery'

import ThumbnailStrip from './ThumbnailStrip'

import {
  ArcadeGalleryContainer,
  GalleryImageWithLoader,
  GalleryImage,
  ThumbnailStripContainer,
  LoaderContainer
} from './styledComponents'
import './index.scss'
import DefaultLoader from './DefaultLoader'

class ArcadeGallery extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedIndex: 0,
      isImageLoaded: false,
      isInitialLoad: true
    }
  }

  onPress = index => {
    const { selectedIndex } = this.state
    if (selectedIndex !== index) {
      this.setState({ selectedIndex: index, isImageLoaded: false })
    }
  }

  showLoader = () => {
    const { isInitialLoad } = this.state
    return !isInitialLoad ? (
      <LoaderContainer>
        <DefaultLoader />
      </LoaderContainer>
    ) : null
  }

  onImageLoaded = () => {
    this.setState({ isImageLoaded: true, isInitialLoad: false })
  }

  render() {
    const { arcadeGalleryData, pagePrefix } = this.props
    const { selectedIndex, isImageLoaded } = this.state
    const currentItem = arcadeGalleryData[selectedIndex]
    return (
      <ArcadeGalleryContainer id={`arcade-gallery-section`}>
        <GalleryImageWithLoader>
          {!isImageLoaded && this.showLoader()}
          <MobileMediaQuery>
            <GalleryImage
              src={currentItem.galleryMobileImageUrl}
              alt={currentItem.galleryImageAltText}
              onLoad={this.onImageLoaded}
              StopRendering
            />
          </MobileMediaQuery>
          <AboveTabletMediaQuery>
            <GalleryImage
              src={currentItem.galleryDesktopImageUrl}
              alt={currentItem.galleryImageAltText}
              onLoad={this.onImageLoaded}
              StopRendering
            />
          </AboveTabletMediaQuery>
        </GalleryImageWithLoader>
        <ThumbnailStripContainer>
          <ThumbnailStrip
            onPress={this.onPress}
            selectedIndex={selectedIndex}
            arcadeGalleryData={arcadeGalleryData}
            pagePrefix={pagePrefix}
          />
        </ThumbnailStripContainer>
      </ArcadeGalleryContainer>
    )
  }
}

export default ArcadeGallery



// WEBPACK FOOTER //
// ./src/components/IbcArcade/ArcadeGallery/index.js